// Envío de ubicación del turno. En segundo plano usa la "llave de turno" (HMAC)
// con fetch puro — SIN pasar por MSAL/axios, que no pueden renovar tokens con la
// app en background (se veían 401). La llave se obtiene al iniciar turno.
import { api } from './api'

const KEY_STORAGE = 'hotel-depot:shiftLocKey'

export interface ShiftKey {
  user_id: string
  key: string
}

export function readShiftKey(): ShiftKey | null {
  try {
    const raw = localStorage.getItem(KEY_STORAGE)
    return raw ? (JSON.parse(raw) as ShiftKey) : null
  } catch {
    return null
  }
}

/** Pide la llave de turno (requiere sesión activa; llamar con la app en primer plano).
 *  Siempre consulta al servidor: además de la llave, MARCA el turno como activo
 *  (server-side), así el mapa muestra al técnico aunque luego calle un rato. */
export async function ensureShiftKey(): Promise<void> {
  const { data } = await api.get<{ data: ShiftKey }>('/locations/key')
  try {
    localStorage.setItem(KEY_STORAGE, JSON.stringify(data.data))
  } catch {
    /* sin almacenamiento: se usará el canal autenticado */
  }
}

export function clearShiftKey(): void {
  try {
    localStorage.removeItem(KEY_STORAGE)
  } catch {
    /* ignora */
  }
}

function beaconHeaders(k: ShiftKey): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    'X-User-Id': k.user_id,
    'X-Shift-Key': k.key,
  }
}

export async function postLocation(lat: number, lng: number, accuracy?: number | null) {
  const k = readShiftKey()
  if (k) {
    // fetch puro con keepalive: sobrevive mejor en segundo plano.
    await fetch('/api/v1/locations/beacon', {
      method: 'POST',
      headers: beaconHeaders(k),
      body: JSON.stringify({ lat, lng, accuracy: accuracy ?? null }),
      keepalive: true,
    })
    return
  }
  await api.post('/locations', { lat, lng, accuracy: accuracy ?? null })
}

export async function postShiftEnd() {
  const k = readShiftKey()
  if (k) {
    await fetch('/api/v1/locations/beacon/shift-end', {
      method: 'POST',
      headers: beaconHeaders(k),
      keepalive: true,
    })
    return
  }
  await api.post('/locations/shift-end')
}
